/**
 * THIS FILE IS AUTOMATICALLY GENERATED BY genColors.js.
 *
 * DO NOT MANUALLY MODIFY THIS FILE.
 */

enum ColorVariableDarkModeName {
  AliceBlue = "--color-aliceBlue-darkMode",
  AntiFlashWhite = "--color-antiFlashWhite-darkMode",
  ArtistPillShadow = "--color-artistPillShadow-darkMode",
  BackgroundOverlay = "--color-backgroundOverlay-darkMode",
  BackgroundOverlayDark = "--color-backgroundOverlayDark-darkMode",
  BlueGradient = "--color-blueGradient-darkMode",
  BrightGray = "--color-brightGray-darkMode",
  BrightPurple = "--color-brightPurple-darkMode",
  CadmiumGreen = "--color-cadmiumGreen-darkMode",
  CardBackground = "--color-cardBackground-darkMode",
  ClickableAreaBackground = "--color-clickableAreaBackground-darkMode",
  Cultured = "--color-cultured-darkMode",
  DarkCerulean = "--color-darkCerulean-darkMode",
  DarkGunmetal = "--color-darkGunmetal-darkMode",
  DarkPurple = "--color-darkPurple-darkMode",
  Dimmer = "--color-dimmer-darkMode",
  Error = "--color-error-darkMode",
  FloatingElement = "--color-floatingElement-darkMode",
  Footer = "--color-footer-darkMode",
  Ghost = "--color-ghost-darkMode",
  Green = "--color-green-darkMode",
  GreenGradient = "--color-greenGradient-darkMode",
  GreenishGray = "--color-greenishGray-darkMode",
  LightBlue = "--color-lightBlue-darkMode",
  LightPink = "--color-lightPink-darkMode",
  LightPurple = "--color-lightPurple-darkMode",
  LightPurpleGradient = "--color-lightPurpleGradient-darkMode",
  LightPurpleHover = "--color-lightPurpleHover-darkMode",
  LightPurpleVerticalGradient = "--color-lightPurpleVerticalGradient-darkMode",
  LinkWater = "--color-linkWater-darkMode",
  MaximumRed = "--color-maximumRed-darkMode",
  MediumBlue = "--color-mediumBlue-darkMode",
  MenuPopup = "--color-menuPopup-darkMode",
  MidnightBlue = "--color-midnightBlue-darkMode",
  Navy = "--color-navy-darkMode",
  NavyHover = "--color-navyHover-darkMode",
  OverlayButton = "--color-overlayButton-darkMode",
  PhantomPurple = "--color-phantomPurple-darkMode",
  Pink = "--color-pink-darkMode",
  PinkVerticalGradient = "--color-pinkVerticalGradient-darkMode",
  PopheadzDarkGray = "--color-popheadzDarkGray-darkMode",
  PopheadzLightGray = "--color-popheadzLightGray-darkMode",
  Primary = "--color-primary-darkMode",
  ProgressBar = "--color-progressBar-darkMode",
  Purple = "--color-purple-darkMode",
  PurpleGradient = "--color-purpleGradient-darkMode",
  PurpleGradientForText = "--color-purpleGradientForText-darkMode",
  PurpleGradientHover = "--color-purpleGradientHover-darkMode",
  Red = "--color-red-darkMode",
  RedGradient = "--color-redGradient-darkMode",
  RedHover = "--color-redHover-darkMode",
  Scheme11 = "--color-scheme11-darkMode",
  Scheme12 = "--color-scheme12-darkMode",
  Scheme21 = "--color-scheme21-darkMode",
  Scheme22 = "--color-scheme22-darkMode",
  Scheme31 = "--color-scheme31-darkMode",
  Scheme32 = "--color-scheme32-darkMode",
  Scheme41 = "--color-scheme41-darkMode",
  Scheme42 = "--color-scheme42-darkMode",
  Scheme51 = "--color-scheme51-darkMode",
  Scheme52 = "--color-scheme52-darkMode",
  Scheme61 = "--color-scheme61-darkMode",
  Scheme62 = "--color-scheme62-darkMode",
  Seashell = "--color-seashell-darkMode",
  Secondary = "--color-secondary-darkMode",
  Shader = "--color-shader-darkMode",
  Sinopia = "--color-sinopia-darkMode",
  SkeletonBase = "--color-skeletonBase-darkMode",
  SkeletonHighlight = "--color-skeletonHighlight-darkMode",
  SpotlightOverlay = "--color-spotlightOverlay-darkMode",
  Tertiary = "--color-tertiary-darkMode",
  Transparent = "--color-transparent-darkMode",
  WebsiteBackground = "--color-websiteBackground-darkMode",
  White = "--color-white-darkMode",
  Yellow = "--color-yellow-darkMode",
}

export default ColorVariableDarkModeName;
